import { mapEnumToOptions } from '@abp/ng.core';

export enum TariffType {
  Port = 0,
  Customer = 1,
  Ctm = 2,
}

export const tariffTypeOptions = mapEnumToOptions(TariffType);
